<div class="container">
    <div class="row">
        <div class="col">
            <strong>{{ "general" | translate }}</strong>
        </div>
    </div>
    <div class="row mt-3">
        <div class="col">
            <app-general-information></app-general-information>
        </div>
    </div>

    <app-signatory-information></app-signatory-information>

    <div [hidden]="!authorizer">
        <app-authorizer-information></app-authorizer-information>
    </div>

    <app-observer-information *ngIf="hasObservers"></app-observer-information>

    <app-responsible-information *ngIf="hasResponsibles"></app-responsible-information>
</div>
